export default "__VITE_ASSET__DqFGSZlt__"